import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { CircleBadge } from 'components/misc'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { ACTIVITY_SECTIONS } from 'constants/enums'

export default class ActivityBadge extends Component {
  static propTypes = {
    activitySection: PropTypes.string,
  }

  render() {
    const { activitySection } = this.props

    return (
      <CircleBadge {...this.props} colorClass={getActivityClassName(activitySection)}>
        {activitySection === ACTIVITY_SECTIONS.skill.id && <i className='ico ico--skill' />}
        {activitySection === ACTIVITY_SECTIONS.service.id && <i className='ico ico--service' />}
        {activitySection === ACTIVITY_SECTIONS.physical_recreation.id && <i className='ico ico--physical_recreation' />}
        {activitySection === ACTIVITY_SECTIONS.adventurous_journey.id && <i className='ico ico--adventurous_journey' />}
        {activitySection === ACTIVITY_SECTIONS.residential_project.id && <i className='ico ico--residential_project' />}
        {activitySection === 'none' && <i />}
      </CircleBadge>
    )
  }
}
